import { Component, OnInit  } from '@angular/core';
import { Router } from "@angular/router";

import { AuthenticationService } from './services/authentication.service';
import { CognitoTokensService } from "./services/cognito/cognito-tokens.service";

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  loading =  false; 
  isSession = false;

	constructor(private authService : AuthenticationService, 
              private router: Router,
              private cognitoTokensService: CognitoTokensService
              ) {
  }

  ngOnInit() {
    this.isSession = this.cognitoTokensService.checkTokenExpiry();

    if(!this.isSession) {
      this.authService.logout();
    }

    setInterval(()=> {      
      if(!this.cognitoTokensService.checkTokenExpiry()) {
        // this.cognitoTokensService.updateTokens();
      }
    },300000); //refresh idToken and accessToken in every 5 minutes.
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts